import React from 'react';

/**
 * The pill beside a chapter in "الأداء حسب الفصل" — Figma node 16370:191274.
 *
 * 12px bold on a fully rounded ground, 10px by 4px of padding, in one of the
 * three pairs the frame draws:
 *
 * | band | ground | lettering |
 * |---|---|---|
 * | `review` — يحتاج مراجعة | red/50 | red/300 |
 * | `average` — أداء متوسط | orange/100 | orange/400 |
 * | `good` — أداء جيد | green/50 | green/200 |
 *
 * Not `StatusTag` or `StatusPill`: those carry a dot, a hairline or a different
 * radius, and each is one design's own.
 */
const BANDS = {
    review: 'tw-bg-v2-no-tint tw-text-v2-no',
    average: 'tw-bg-v2-student-caution-tint tw-text-v2-student-caution',
    good: 'tw-bg-v2-student-good-tint tw-text-v2-yes',
};

const BandBadge = ({ band, children }) => (
    <span
        className={
            'tw-inline-flex tw-shrink-0 tw-items-center tw-whitespace-nowrap tw-rounded-full tw-px-[10px] tw-py-[4px] ' +
            `tw-text-[12px] tw-font-bold tw-leading-[normal] ${BANDS[band] ?? BANDS.review}`
        }
    >
        {children}
    </span>
);

export default BandBadge;
